import { CollectionsModal } from './CollectionsModal'

export default CollectionsModal
